// collection-card
export const ratioRegex = /(\d)-(\d)/;
export const sizes = ['xs', 'md', 'lg'] as const;
